export enum IEndorsements {
  TANKER = 'tanker',
  TWIC = 'twic',
  DOUBLE_TRAILER = 'double_trailer',
  HAZMAT = 'hazmat',
}

export const ENDORSEMENTS_LABELS: Record<IEndorsements, string> = {
  [IEndorsements.TANKER]: 'Tanker',
  [IEndorsements.TWIC]: 'Twic',
  [IEndorsements.DOUBLE_TRAILER]: 'Double Trailer',
  [IEndorsements.HAZMAT]: 'Hazmat',
}
